export enum ItemLocation {
    Unknown = -1,
    Any = 0,
    Bags = 1,
    Bank = 2,
    Reagent = 3,
    GuildBank = 4,
    WarbandBank = 5,
    PetCollection = 10,
    Equipped = 100,
}
